import { signOut } from "firebase/auth";
import { authService } from "../../firebase-config";

class AuthManager {
  private static instance: AuthManager;

  public static get(): AuthManager {
    if (!this.instance) {
      this.instance = new AuthManager();
    }
    return this.instance;
  }

  getAuthToken(): string | undefined {
    return authService.currentUser?.uid;
  }

  isLoggedIn(): boolean {
    return !!authService.currentUser;
  }

  async logout(): Promise<void> {
    try {
      await signOut(authService);
    } catch (error) {
      console.error("Error en logout:", error);
    }
  }
}

export const authManager = AuthManager.get();
